import React from 'react';
import { SketchPicker } from 'react-color';
import { autobind } from 'core-decorators';
import { FormGroup } from 'reactstrap';

import guid from '../../utils/guid';

const SWATCH_SIZE_SQUARE = 32;

@autobind
class Color extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayColorPicker: false,
      color: {
        r: '241',
        g: '112',
        b: '19',
        a: '1',
      },
    };
    this.guid = 'color' + guid();
  }

  handleClick() {
    if (!this.props.disabled) {
      if (this.state.displayColorPicker == true)
        if (this.props.getAlteracao) this.props.getAlteracao();

      this.setState({ displayColorPicker: !this.state.displayColorPicker });
    }
  }

  handleClose() {
    this.setState({ displayColorPicker: false });
  }

  handleChange(color) {
    this.setState({ color: color.rgb });
    this.props.model.requestChange(color.hex);

    if (this.props.getAlteracao) this.props.getAlteracao();
  }

  render() {
    const {
      model,
      required,
      position,
      formStyle = {},
      hideLabel = false,
      swatchSize,
      pickerPopupAlign,
    } = this.props;
    const cor =
      this.props.model && this.props.model.value ? this.props.model.value : '';

    const swatchSquare = swatchSize === SWATCH_SIZE_SQUARE;
    const outerStyle = {
      padding: '5px',
      width: `${SWATCH_SIZE_SQUARE}px`,
      height: swatchSquare ? `${SWATCH_SIZE_SQUARE}px` : 24,
      background: '#fff',
      borderRadius: '4px',
      boxSizing: 'border-box',
      boxShadow: `${
        model.errors
          ? '0 0 0 1px rgba(217,83, 79, 0.8)'
          : '0 0 0 1px rgba(0,0,0,.1)'
      }`,
      cursor: 'pointer',
    };
    const innerStyle = {
      width: '100%',
      height: swatchSquare ? '100%' : '14px',
      borderRadius: '2px',
      background: cor,
    };

    const anchorEnd = pickerPopupAlign === 'end';
    const pickerStyle = anchorEnd
      ? {
          position: 'absolute',
          zIndex: 20,
          top: '100%',
          left: 'auto',
          right: 0,
          marginTop: '4px',
        }
      : {
          position: position ? position : 'absolute',
          zIndex: 20,
        };

    const swatchEl = (
      <div id={this.guid} onClick={this.handleClick}>
        <div style={outerStyle}>
          <div style={innerStyle} />
        </div>
      </div>
    );

    const pickerEl = this.state.displayColorPicker && (
      <div style={pickerStyle}>
        <SketchPicker
          color={cor}
          onChange={this.handleChange}
          disableAlpha
        />
      </div>
    );

    return (
      <FormGroup style={formStyle} onMouseLeave={this.handleClose}>
        {!hideLabel && (
          <label className="control-label">
            {model.label} {required ? '*' : ''}
          </label>
        )}

        {anchorEnd ? (
          <div style={{ position: 'relative', display: 'inline-block' }}>
            {swatchEl}
            {pickerEl}
          </div>
        ) : (
          <>
            {swatchEl}
            {pickerEl}
          </>
        )}
      </FormGroup>
    );
  }
}

export default Color;
